import { useField } from "formik";
import React from "react";
import styled from "styled-components";

const OptionFieldElement = styled.label`
  display: flex;
  align-items: center;
  gap: 1ch;

  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  padding: var(--spacing-default);
  background-color: hsla(var(--backgroundHSL), 50%);
  border-radius: 5px;
  &[data-is-checked="true"] [data-description] {
    opacity: 1;
  }
`;

export const RadioOptionFieldGroup = styled.div`
  --radio-option-field-border-radius: 10px;
  --radio-option-field-group-gap: 2px;

  border-radius: var(--radio-option-field-border-radius);
  border: 1px solid rgba(255, 255, 255, 0.1);

  & ${OptionFieldElement} {
    border-radius: 0;
  }
  & ${OptionFieldElement}:first-child {
    border-radius: var(--radio-option-field-border-radius)
      var(--radio-option-field-border-radius) 0 0;
  }
  & ${OptionFieldElement}:last-child {
    border-radius: 0 0 var(--radio-option-field-border-radius)
      var(--radio-option-field-border-radius);
  }
  & ${OptionFieldElement} + ${OptionFieldElement} {
    margin-top: var(--radio-option-field-group-gap);
  }
`;

const Radio = styled.input.attrs({ type: "radio" })`
  --radio-outer-size: calc(1rem + 4px);
  --radio-inner-size: 1rem;
  display: grid;
  place-items: center;
  appearance: none;
  position: relative;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  background: hsla(var(--backgroundHSL), 0.1);
  width: var(--radio-outer-size);
  height: var(--radio-outer-size);
  cursor: pointer;
  margin-right: 1ch;
  &::before {
    opacity: 0;
    content: "";
    display: block;
    position: absolute;
    border-radius: 50%;
    width: var(--radio-inner-size);
    height: var(--radio-inner-size);
    background-color: var(--success);
    transition: opacity 0.25s ease-out;
  }
  &:checked::before {
    opacity: 1;
  }
`;

const OptionLabelContainer = styled.span``;
const OptionLabel = styled.div`
  display: block;
  margin-bottom: 4px;
  font-weight: 600;
`;
const OptionDescription = styled.div`
  font-size: 87.5%;
  opacity: 0.5;
  max-width: 375px;
`;

type Props = {
  name: string;
  value?: string;
  type?: string;
  label?: string;
  description?: React.ReactNode;
};
const RadioOptionField: React.FC<Props> = ({
  label,
  description,
  ...props
}) => {
  const [field] = useField(props);
  const content = (
    <OptionLabelContainer>
      <OptionLabel data-label>{label}</OptionLabel>
      <OptionDescription data-description>{description}</OptionDescription>
    </OptionLabelContainer>
  );
  return (
    <OptionFieldElement data-is-checked={field.checked}>
      <Radio {...field} />
      {content}
    </OptionFieldElement>
  );
};

export default RadioOptionField;
